import React from 'react';
import Dropzone from 'react-dropzone';
import styled from 'styled-components';
import { CloudUpload } from '@material-ui/icons';
import { ButtonBase, Typography } from '@material-ui/core';
import UploadProgress from './UploadProgress';
import { checkFileType } from '../../utils/checkFileType';

const Emphasize = styled.span`
  color: ${(props) => props.theme.palette.primary.main};
  text-decoration: underline;
`;

const Outline = styled(ButtonBase)`
  border: 2px dashed #cecece;
  display: flex;
  flex-direction: column;
  padding: 16px;
  width: 100%;
`;

interface IProps {
  /**
   * Returns the files dropped in the dropzone.
   */
  attachments: File[];
  onDrop: (files: File[]) => void;
  onDelete: (file: File) => void;
  maxFiles: number;
}

const AttachmentDropzone: React.FC<IProps> = ({
  attachments,
  onDrop,
  onDelete,
  maxFiles = 0,
}) => {
  const [errorMessage, setErrorMessage] = React.useState<string>('');

  const onFileDrop = (files: File[]) => {
    onDrop(
      files.filter(
        (file) =>
          checkFileType(file) &&
          !attachments.some((attachment) => attachment.name === file.name)
      )
    );
  };

  return (
    <Dropzone onDrop={onFileDrop} maxFiles={maxFiles}>
      {({ getRootProps, getInputProps }) => (
        <>
          <Outline {...getRootProps()}>
            <CloudUpload color='disabled' fontSize='large' />
            <input {...getInputProps()} />
            <Typography variant='body1'>
              Drag and drop or <Emphasize>browse</Emphasize>
            </Typography>
          </Outline>
          {Boolean(errorMessage) ? (
            <Typography variant='caption' color='error'>
              {errorMessage}
            </Typography>
          ) : null}
          {attachments.map((attachment, index) => (
            <UploadProgress key={index} file={attachment} onDelete={onDelete} />
          ))}
        </>
      )}
    </Dropzone>
  );
};

export default AttachmentDropzone;
